import { initialSignalTranslationEquationState } from './initialState';

import {
  SIGNALTRANSLATION_EQUATION_ERROR,
  GET_ALL_SIGNALTRANSLATION_EQUATION_DETAILS,
  SIGNALTRANSLATION_EQUATION_IS_LOADING,
  SET_SIGNALTRANSLATION_EQUATION_CURRENT_PAGE,
  SET_SIGNALTRANSLATION_EQUATION_PAGE_FILTER,
  SET_SIGNALTRANSLATION_EQUATION_CHANGE,
  SET_SIGNALTRANSLATION_EQUATION_CLEANUP,
  SET_SIGNALTRANSLATION_EQUATION,
  UPDATE_SIGNALTRANSLATION_EQUATION_SAVE_STATUS,
  SET_SIGNALTRANSLATION_EQUATION_CONSTANT_CHANGE,
  SET_SIGNALTRANSLATION_EQUATION_CONSTANT_LIST_CHANGE,
  SHOW_SIGNALTRANSLATION_EQUATION_CONSTANT_ADD_EDIT_SCREEN
} from '../constants/index';

const signalTranslationEquationReducer = (state = initialSignalTranslationEquationState, action) => {
  const { payload, type } = action;

  switch (type) {
    case GET_ALL_SIGNALTRANSLATION_EQUATION_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          ...data
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          currentPage
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          filter
        }
      };
    }

    case UPDATE_SIGNALTRANSLATION_EQUATION_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          ...data
        }
      };
    }

    case SIGNALTRANSLATION_EQUATION_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          isLoading: isLoading
        }
      };
    }

    case SIGNALTRANSLATION_EQUATION_ERROR: {
      const { data } = payload;
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          ...data
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION: {
      let SelectedSignalTranslationEquation = payload;

      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SelectedSignalTranslationEquation: {
            ...state.signalTranslationEquation.SelectedSignalTranslationEquation,
            ...SelectedSignalTranslationEquation
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_CHANGE: {
      let { SelectedSignalTranslationEquation } = payload;

      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SelectedSignalTranslationEquation: {
            ...state.signalTranslationEquation.SelectedSignalTranslationEquation,
            ...SelectedSignalTranslationEquation
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_CONSTANT_CHANGE: {
      let { SelectedEquationConstant } = payload;

      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SelectedSignalTranslationEquation: {
            ...state.signalTranslationEquation.SelectedSignalTranslationEquation,
            EquationConstants: {
              ...state.signalTranslationEquation.SelectedSignalTranslationEquation.EquationConstants,
              SelectedEquationConstant: {
                ...SelectedEquationConstant
              }
            }
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_CONSTANT_LIST_CHANGE: {
      let { EquationConstantList } = payload;

      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SelectedSignalTranslationEquation: {
            ...state.signalTranslationEquation.SelectedSignalTranslationEquation,
            EquationConstants: {
              ...state.signalTranslationEquation.SelectedSignalTranslationEquation.EquationConstants,
              EquationConstantList: EquationConstantList
            }
          }
        }
      };
    }

    case SHOW_SIGNALTRANSLATION_EQUATION_CONSTANT_ADD_EDIT_SCREEN: {
      let { showAddEditScreen } = payload;

      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SelectedSignalTranslationEquation: {
            ...state.signalTranslationEquation.SelectedSignalTranslationEquation,
            EquationConstants: {
              ...state.signalTranslationEquation.SelectedSignalTranslationEquation.EquationConstants,
              showAddEditScreen: showAddEditScreen
            }
          }
        }
      };
    }

    case SET_SIGNALTRANSLATION_EQUATION_CLEANUP: {
      return {
        ...state,
        signalTranslationEquation: {
          ...state.signalTranslationEquation,
          SignalTranslationEquationList: [],
          SelectedSignalTranslationEquation: {
            SignalTranslationEquationId: 0,
            Name: '',
            Description: '',
            GuidIdentifier: '',
            IsActive: true,
            EquationConstants: {
              EquationConstantList: [],
              SelectedEquationConstant: {
                SignalTranslationEquationConstantId: 0,
                SignalTranslationEquationId: 0,
                Name: '',
                Description: '',
                Formula: '',
                GuidIdentifier: '',
                isChanged: 0,
                IsActive: true,
                OrderNumber: 0
              },
              showAddEditScreen: false
            }
          }
        }
      };
    }

    default:
      return state;
  }
};

export default signalTranslationEquationReducer;
